import { useEffect, useState } from 'react';
import StepFormTemplate from "../../templates/step-form.template";
import { useNavigate } from 'react-router-dom';
import AddressInfoForm from '../../templates/address-info-form.template';
import { getZipCodeInfo } from "../../../services/new-services/public-v2.services.js";
import { useDispatch } from "react-redux";
import { updateAddress } from "../../../redux/slices/application-process.slice.js";

const ApplicationSecondStepScreen = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        zipCode: '',
        addressLine1: '',
        neighborhood: '',
        extNumber: '',
        addressLine2: ''
    });
    const [errors, setErrors] = useState({
        zipCode: '',
    });
    const [neighborhoodOptions, setNeighborhoodOptions] = useState([]);
    const [selectedNeighborhood, setSelectedNeighborhood] = useState(null);
    const [submitEnabled, setSubmitEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleFormChange = (field) => (value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    useEffect(() => {
        if (formData.zipCode.length === 5) {
            setIsLoading(true);
            getZipCodeInfo(formData.zipCode).then(res => {
                if (!res.success || res.data.length === 0) {
                    setErrors({
                        zipCode: 'Codigo invalido'
                    });
                    setIsLoading(false);
                    return;
                }
                const neighborhoodOptions = res.data?.map((x, index) => {
                    return {
                        id: index,
                        label: x.asentamiento,
                        value: x,
                    };
                });
                setErrors({
                    zipCode: ''
                })
                setNeighborhoodOptions(neighborhoodOptions);
                setIsLoading(false);
            })
        }
    }, [formData.zipCode]);

    useEffect(() => {
        let isEnabled =
            formData.addressLine1.length > 0 &&
            formData.extNumber.length > 0 &&
            !!selectedNeighborhood &&
            formData.zipCode.length === 5;
        setSubmitEnabled(isEnabled);
    }, [formData]);

    function handleSubmit() {
        dispatch(updateAddress(
            {
                addressLine1: formData.addressLine1,
                extNumber: formData.extNumber,
                addressLine2: formData.addressLine2,
                neighborhood: selectedNeighborhood.asentamiento,
                zipCode: formData.zipCode,
                city: selectedNeighborhood.ciudad,
                state: selectedNeighborhood.estado,
            }
        ));
        navigate('/app/application/third-step');
    }

    return (
        <div style={styles.mainContainerStyle}>
            <StepFormTemplate
                title="Domicilio"
                description="Ingresa tu domicilio tal como aparece en tu INE"
                currentStep={3}
                totalSteps={5}
                submitEnabled={submitEnabled}
                onSubmit={handleSubmit}
                onClose={() => {
                    navigate('/')
                }}
            >
                <AddressInfoForm
                    isLoading={isLoading}
                    errors={errors}
                    zipCode={formData.zipCode}
                    onZipCodeChange={handleFormChange('zipCode')}
                    street={formData.addressLine1}
                    onStreetChange={handleFormChange('addressLine1')}
                    neighborhood={selectedNeighborhood}
                    neighborhoodOptions={neighborhoodOptions}
                    onNeighborhoodChange={setSelectedNeighborhood}
                    externalNumber={formData.extNumber}
                    onExternalNumberChange={handleFormChange('extNumber')}
                    internalNumber={formData.addressLine2}
                    onInternalNumberChange={handleFormChange('addressLine2')}
                />
            </StepFormTemplate>
        </div>
    );
};

const styles = {
    mainContainerStyle: {
        margin: '0 auto',
        padding: window.innerWidth > 700 ? '0 25%' : '0'
    }
}

export default ApplicationSecondStepScreen;